import { Pagination, Select, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { transientProps } from '@/app/styles/styledHelpers';
import { DealsButton } from './../../../styles/StyledButtons';

export const GridColActionsWrapper = styled('div')<{ margin?: string }>`
&& {
    margin: ${({ margin }) => margin ?? '-18px'};
    pointer-events: none;
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
`;

export const GridWrapper = styled('div')<{
  $height?: string;
  $gridHighlightColor?: string;
  $enabled?: boolean;
  $isFullHeightColumn?: boolean;
  $applyPadding?: boolean;
  $hideFooter?: boolean;
  $disablePointer?: boolean;
  $gridBorderColor?: string;
  $autoHeight?: boolean;
  $isFlexible?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: ${({ $height }) => $height || '100%'};
  min-height: ${({ $enabled }) => ($enabled ? '100px' : 'auto')};
  border: 1px solid ${({ $gridBorderColor, theme }) => $gridBorderColor || theme.palette.grey[500]};
  margin-bottom: 10px;
  border-radius: ${({ $gridBorderColor }) => ($gridBorderColor ? '4px' : '8px')};

  overflow: ${({ $autoHeight }) => ($autoHeight ? 'visible' : 'hidden')};

  div.MuiDataGrid-columnHeaderTitle {
    white-space: nowrap;
  }
    .MuiTableContainer-root {
    min-height: auto !important;
    /* margin-bottom: 12px; */
  }

  .MuiTableCell-head {
    white-space: nowrap;
    font-weight: 700;
  }
    .phoenix-grid-footer {
    background-color: white;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px;
    min-height: 40px;
    position:relative;
  }

  .MuiTypography-h3 {
	color: ${({ theme }) => theme.palette.common.black};
  }

  .MuiDataGrid-columnHeaders {
    height: 40px;
    min-height: 0 !important;
  }

  .MuiDataGrid-cell {
    min-height: 40px !important;
  }
    .MuiTableHead-root .MuiTableRow-root {
    height: 40px;
  }

  .MuiTableCell-root {
    min-height: 40px;
    line-height: 1.5;
  }

  .MuiTableCell-head {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  .phoenix-grid-footer {
    background-color: white;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding:  12px;
    min-height: 40px;
  }

  ${({ $gridHighlightColor, theme }) => $gridHighlightColor && `
    .MuiDataGrid-columnHeaders {
      background-color: ${$gridHighlightColor};
    }

    .MuiDataGrid-columnSeparator {
    	color: ${theme.palette.secondary.dark};
    }
  `}

  ${({ $hideFooter }) => $hideFooter && `
    div.MuiDataGrid-footerContainer {
      display: none;
    }
  `}

  ${({ $isFullHeightColumn }) => $isFullHeightColumn && `
    .MuiDataGrid-cell, .MuiDataGrid-row {
      max-height: none !important;
      white-space: inherit !important;
      overflow-wrap: anywhere;
    }
  `}

  ${({ $isFlexible }) => $isFlexible && `
    .MuiDataGrid-cell {
      word-break: break-word;
    } 

    .MuiDataGrid-cell,
    .MuiDataGrid-row,
    .MuiDataGrid-columnHeaders,
    .MuiDataGrid-columnHeaderTitle,
    .MuiDataGrid-columnHeader {
      max-height: none !important;
      white-space: normal !important;
    }
  `}

    .MuiDataGrid-row {
    cursor: ${({ $disablePointer }) => ($disablePointer ? 'default' : 'pointer')};
  }
  .MuiDataGrid-filterIcon {
    color: ${({ theme }) => theme.palette.primary.main};
  }
  .MuiTableContainer-root {
    min-height: auto !important;
    /* margin-bottom: 12px; */
  }

  .MuiTableCell-head {
    white-space: nowrap;
    font-weight: 700;
  }

  .MuiTypography-h3 {
    color: ${({ theme }) => theme.palette.common.black};
  }

  .MuiTableHead-root .MuiTableRow-root {
    height: 40px;
  }

  .MuiTableCell-root {
    min-height: 40px;
    line-height: 1.5;
  }

  .MuiTableCell-head {
    padding-top: 2px;
    padding-bottom: 2px;
  }


  ${({ $hideFooter }) =>
    $hideFooter &&
    `
          .phoenix-grid-footer {
            display: none;
            }
        `}
  
        ${({ $isFullHeightColumn }) =>
    $isFullHeightColumn &&
    `
          .MuiTableCell-root, .MuiTableRow-root {
            max-height: none !important;
            white-space: inherit !important;
            overflow-wrap: anywhere;
          }
        `}
      
        ${({ $isFlexible }) =>
    $isFlexible &&
    `
          .MuiTableCell-root {
            word-break: break-word;
          }
      
          .MuiTableCell-root,
          .MuiTableRow-root,
          .MuiTableHead-root {
            max-height: none !important;
            white-space: normal !important;
          }
        `}
      
      .MuiTableBody-root .MuiTableRow-root {
    cursor: ${({ $disablePointer }) => ($disablePointer ? 'default' : 'pointer')};
  }

  .phoenix-grid-cell-pinned-start {
    position: sticky;
    left: var(--pin-offset, 0);
    z-index: 2;
    background: inherit;
  }

  .phoenix-grid-cell-pinned-end {
    position: sticky;
    right: var(--pin-offset, 0);
    z-index: 2;
    background: inherit;
  }
`;

export const FilterPanelApplyButton = styled(DealsButton)`
  position: relative;
`;

export const FilterPanelClearAllButton = styled(DealsButton)`
  position: relative;
`;

export const StyledPagination = styled(Pagination, { shouldForwardProp: transientProps })<{ $paginationIconColor?: string; $paginationIconBgColor?: string }>`
  && .Mui-selected {
    background-color: ${({ $paginationIconBgColor, theme }) => $paginationIconBgColor || theme.palette.primary.light};
    color: ${({ $paginationIconColor, theme }) => $paginationIconColor || theme.palette.common.white};

    &:hover {
      background-color: ${({ $paginationIconBgColor, theme }) => !$paginationIconBgColor && theme.palette.primary.main};
      color: ${({ $paginationIconColor, theme }) => !$paginationIconColor && theme.palette.common.white};
    }
        {
            background-color: ${({ $paginationIconBgColor, theme }) => !$paginationIconBgColor && theme.palette.primary.main};
            color: ${({ $paginationIconColor, theme }) => !$paginationIconColor && theme.palette.common.white};
          }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    && .MuiPaginationItem-root {
      font-size: 11px;
      min-width: 22px;
      height: 22px;
      border-radius: 11px;
      padding: 0 3px;
    }
  }
`;

export const StyledDropdown = styled(Select)`
  background: transparent;
  border: none;
  max-width: 185px;

  & .MuiSelect-select {
    border-radius: 6px;
    min-height: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0px 28px 0px 0px !important;

    svg {
      fill: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

export const TooltipTyporaphy = styled(Typography, { shouldForwardProp: transientProps })<{ line: number; $isBold: boolean; $isWordBreak: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  word-break: ${({ $isWordBreak }) => $isWordBreak && 'break-word'};
  font-weight: ${({ $isBold }) => $isBold && 'bold !important'};

  ${({ line }) =>
    line > 1
      ? `
      white-space: normal;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: ${line};
      line-clamp: ${line};
    `
      : ''}
`;
